export const STOCK_VOLUME_CHART_ENDPOINT = '/stock-api/chart/v1/stock-volume';
export const FILL_RATE_CHART_ENDPOINT = '/stock-api/chart/v1/fill-rate';
export const CONSUMPTION_RATE_CHART_ENDPOINT = '/stock-api/chart/v1/consumption-rate';
